import { useWorkspace } from '../workspace';
import { useSuspenseFeatureAccess } from '../workspace/useSuspenseFeatureAccess';

export function useDataQualityAccess() {
	const { workspace } = useWorkspace();
	const { dqsAccess } = useSuspenseFeatureAccess();

	return !!workspace?.quality_enabled && !!dqsAccess;
}
